import React, { useEffect } from "react";
import { connect } from "react-redux";
import { useParams, Navigate } from "react-router-dom";
import { fetchClientSettings, setCurrentClient } from "../../actions/thunks";

const CommunityPage = ({ auth, dispatch }) => {
  const params = useParams();

  useEffect(() => {
    const communityId = parseInt(params?.communityId || 0);
    const community = auth.user?.clients?.find(
      (client) => client.id === communityId,
    );

    if (community) {
      dispatch(setCurrentClient(community)).then(() => {
        dispatch(fetchClientSettings());
      });
    }
  }, [params?.communityId, auth.user?.clients, dispatch]);

  return <Navigate to={{ pathname: "/" }} />;
};

export default connect((store) => ({
  auth: store.auth,
}))(CommunityPage);
